import { render } from "./XIconSolidUserList.vue?vue&type=template&id=a0995e58"
import script from "./XIconSolidUserList.vue?vue&type=script&lang=js"
export * from "./XIconSolidUserList.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidUserList.vue"]])

export default __exports__